<template>
    <common-modal class="preview-user" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <div class="preview-user--header">
                <common-user-avatar :user="userPreview" :shouldLeadToProfile="false" size="medium"></common-user-avatar>
                <span>{{ userPreview.firstName }} {{ userPreview.lastName }}</span>
            </div>
            <div v-if="userPreview?.descriptionTextContent?.originalText" class="preview-user--description">
                {{ getTranslation(userPreview?.descriptionTextContent) }}
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import TranslateMixin from 'mixins/TranslateMixin'
    export default {
        mixins: [TranslateMixin],
        components: {},
        props: {
            userPreview: { type: Array, required: true },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .preview-user {
        &--header {
            display: flex;
            align-items: center;

            .avatar {
                margin-right: 20px;
            }
        }
    }

    .subdomain-layout--navy_black,
    .subdomain-layout--black {
        .preview-user {
            &--header {
                color: $color--txt-base-3;
            }

            &--description {
                color: $color--txt-base-3;
            }
        }
    }
</style>
